const StatsSection = () => {
  const stats = [
    {
      icon: 'ri-user-smile-line',
      number: '5000+',
      label: 'عميل راضٍ',
    },
    {
      icon: 'ri-shirt-line',
      number: '15000+',
      label: 'ثوب مفصل',
    },
    {
      icon: 'ri-award-line',
      number: '15+',
      label: 'سنة خبرة',
    },
    {
      icon: 'ri-star-line',
      number: '100%',
      label: 'جودة مضمونة',
    },
  ];

  return (
    <section className="py-20 bg-accent">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-2">{stat.number}</h3>
              <p className="text-lg text-white/90">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
